<template>
	<SliderPanel
		v-if="type == 'slideshow'"
		:title="headerTitle"
		headerStyle="slideshow"
		:modal="true"
		size="full"
		:icon="iconHeader"
		:dismissable="false" @closed="emit('closed')"
	>
	<div class="p-3">
		<iframe :src="iframeUrl" class="w-full h-100vh overflow-hidden" style="max-height: calc(100vh - 85px);"></iframe>
	</div>
	</SliderPanel>
	<SliderPanel
		v-else-if="type == 'lngReviewEdit' && configcollection?.id != 'language_review'"
		:title="headerTitle"
		headerStyle="lngReviewEdit"
		:modal="true"
		:size="panelSize"
		:icon="iconHeader"
		:dismissable="false" @closed="emit('closed')"
	>	
			<iframe :src="iframeUrl" class="w-full h-100vh overflow-hidden" style="max-height: calc(100vh);"></iframe>
	</SliderPanel>

	<SliderPanel
		v-else-if="type == 'slideshowEdit'"
		:title="headerTitle"
		headerStyle="slideshowEdit"
		:size="panelSize"
		:icon="iconHeader"
		:dismissable="false" @closed="emit('closed')"
	>
		<iframe :src="iframeUrl" class="w-full h-100vh overflow-hidden"></iframe>
	</SliderPanel>
	<SliderPanel
		v-else-if="type == 'print'"
		:title="headerTitle"
		headerStyle="print"
		:size="panelSize"
		:icon="iconHeader"
		:dismissable="false" @closed="emit('closed')"
	>
		<iframe :src="iframeUrl" class="w-full h-100vh overflow-hidden" style="max-height: calc(100vh - 85px);"></iframe>
	</SliderPanel>
	<SliderPanel
		v-else-if="type == 'feedback'"
		:title="headerTitle"
		headerStyle="feedback"
		:size="panelSize"
		:icon="iconHeader"
		:dismissable="false" @closed="emit('closed')"
	>
		<iframe :src="iframeUrl" class="w-full h-100vh overflow-hidden" style="max-height: calc(100vh - 85px);"></iframe>
	</SliderPanel>
	<SliderPanel
		v-else-if="type == 'notification'"
		:title="headerTitle"
		headerStyle="notification"
		:size="panelSize"
		:icon="iconHeader"
		:dismissable="false" @closed="emit('closed')"
	>
		<iframe id="notifyIframe" :src="iframeUrl" class="w-full h-100vh overflow-hidden" style="max-height: calc(100vh - 56px);"></iframe>
	</SliderPanel>
	<SliderPanel
		v-else-if="type == 'imagelist'"
		:title="headerTitle"
		headerStyle="dark"
		:size="panelSize"
		:icon="iconHeader"
		:dismissable="false" @closed="emit('closed')"
	>
		<iframe :src="iframeUrl" class="w-full h-100vh overflow-hidden"></iframe>
	</SliderPanel>
	<SliderPanel
		v-else-if="type == 'imageattr'"
		:title="headerTitle"
		headerStyle="dark"
		:size="panelSize"
		:icon="iconHeader"
		:dismissable="false" @closed="emit('closed')"
	>
		<iframe :src="iframeUrl" class="w-full h-100vh overflow-hidden" style="max-height: calc(100vh - 85px);"></iframe>
	</SliderPanel>
	<SliderPanel
		v-else-if="type == 'listattr' || type == 'details' || type == 'prequiz' || type == 'podcast' || type == 'new' || type == 'newmodels' || type == 'editmodels' || type == 'inputResources' || type == 'newImage'  || type == 'editPackage'"
		:title="headerTitle"
		headerStyle="dark"
		:size="panelSize"
		:icon="iconHeader"
		:dismissable="false" @closed="emit('closed')"
	>
		<iframe :src="iframeUrl" class="w-full h-100vh overflow-hidden"></iframe>
	</SliderPanel>
	<SliderPanel
		v-else-if="type == 'postquiz' || type == 'references' || type == 'podcast'"
		:title="headerTitle"
		headerStyle="dark"
		:size="panelSize"
		:icon="iconHeader"
		:dismissable="false" @closed="emit('closed')"
	>
		<iframe :src="iframeUrl" class="w-full h-100vh overflow-hidden" style="max-height:calc( 100vh - 18px)" ></iframe>
	</SliderPanel>

	<SliderPanel v-else-if="type != 'finishassistantMode' && type != 'configButtonMode' && type != 'listattr' && type != 'assistantMode' && type != 'complainceAssistantMode' && type != 'helpSupportAssistant' && type != 'reportassistantMode' && type != 'examinerAssistantMode' && type != 'readCallAssistantButton' && type != 'feedbackAssistantMode' && type != 'print'" :title="headerTitle" headerStyle="dark" :dismissable="false" @closed="emit('closed')" :size="panelSize" :icon="iconHeader">
		<iframe :src="iframeUrl" class="w-full h-100vh overflow-hidden" style="max-height: calc(100vh - 85px);"></iframe>
	</SliderPanel>

	<SliderPanel
		v-else-if="type == 'finishassistantMode' || type == 'configButtonMode' || type == 'assistantMode' "
		:title="headerTitle"
		headerStyle="author"
		:size="panelSize"
		:icon="iconHeader"
		:dismissable="false" @closed="emit('closed')"
	>
		<iframe :src="iframeUrl" class="w-full h-100vh overflow-hidden"></iframe>
	</SliderPanel>
	<SliderPanel
		v-else-if="type == 'complainceAssistantMode'"
		:title="headerTitle"
		headerStyle="helpSupportAssistant"
		:size="panelSize"
		:icon="iconHeader"
		:dismissable="false" @closed="emit('closed')"
	>
		<iframe :src="iframeUrl" class="w-full h-100vh overflow-hidden"></iframe>
	</SliderPanel>
	<SliderPanel
		v-else-if="type == 'helpSupportAssistant'"
		:title="headerTitle"
		headerStyle="helpSupportAssistant"
		:size="panelSize"
		:icon="iconHeader"
		:dismissable="false" @closed="emit('closed')"
	>
		<iframe :src="iframeUrl" class="w-full h-100vh overflow-hidden"></iframe>
	</SliderPanel>
	<SliderPanel
		v-else-if="type == 'feedbackAssistantMode'"
		:title="headerTitle"
		headerStyle="helpSupportAssistant"
		:size="panelSize"
		:icon="iconHeader"
		:dismissable="false" @closed="emit('closed')"
	>
		<iframe :src="iframeUrl" class="w-full h-100vh overflow-hidden"></iframe>
	</SliderPanel>
	<SliderPanel
		v-else-if="type == 'reportassistantMode'"
		:title="headerTitle"
		headerStyle="helpSupportAssistant"
		:size="panelSize"
		:icon="iconHeader"
		:dismissable="false" @closed="emit('closed')"
	>
		<iframe :src="iframeUrl" class="w-full h-100vh overflow-hidden"></iframe>
	</SliderPanel>
	<SliderPanel
		v-else-if="type == 'examinerAssistantMode'"
		:title="headerTitle"
		headerStyle="helpSupportAssistant"
		:size="panelSize"
		:icon="iconHeader"
		:dismissable="false" @closed="emit('closed')"
	>
		<iframe :src="iframeUrl" class="w-full h-100vh overflow-hidden"></iframe>
	</SliderPanel>
	<SliderPanel
		v-else-if="type == 'readCallAssistantButton'"
		:title="headerTitle"
		headerStyle="readCallAssistant"
		:size="panelSize"
		:icon="iconHeader"
		:dismissable="false" @closed="emit('closed')"
	>
		<iframe :src="iframeUrl" class="w-full h-100vh overflow-hidden"></iframe>
	</SliderPanel>

</template>

<script setup lang="ts">
import { defineProps } from 'vue';
import SliderPanel from '../components/SidebarPanel/SidebarPanel.vue';
import { messages } from '@/assets/language'
import { useAppStore } from '@/stores/app-store'
import {useAppConfig} from '@/composables/useAppConfig';

import type { configCollectionMode } from '@/types';

const { currentLng } = useAppStore()

const labels = computed( () => {
	const key = currentLng.value as keyof typeof messages
	return messages[key] ?? {}
} )

const emit = defineEmits<{
  (e: 'closed'): void
}>()

const props = defineProps<{
	id: string | null;
	type: string | null;
	headerStyle?: string;
	overrideURL?: string;
	headerTitle?: string;
	size?: string;
	configcollection: configCollectionMode | null

}>();

const AppConfig = useAppConfig();

const PrintRoute = computed(() => {
	const baseUrl = AppConfig.detailsUrlTarget ? `${AppConfig.detailsUrlTarget}#/` : '#/'
	return `${baseUrl}print/${props.id}?lng=${currentLng.value}`;
})
const presentationRoute = computed(() => {
	const baseUrl = AppConfig.detailsUrlTarget ? `${AppConfig.detailsUrlTarget}#/` : '#/'
	return `${baseUrl}details/${props.id}/presenation/${props.id}?lng=${currentLng.value}`;
})
const allowedSizes = ['lngReviewEdit', 'xxl', 'xl', 'sm', 'md', 'lg', 'full'] as const;
type AllowedSize = typeof allowedSizes[number];

const panelSize = computed<AllowedSize | undefined>(() => {
  if (allowedSizes.includes(props.size as AllowedSize)) {
    return props.size as AllowedSize;
  }

  switch (props.type) {
    case 'slideshow':
      return 'full';
    case 'lngReviewEdit':
      return 'lngReviewEdit';
    default:
      return 'xl';
  }
});

const iconHeader = computed(() => {
	switch (props.type) {
		case 'new':
			return 'tabler:plus';
		case 'models':
			return 'tabler:plus';
		case 'inputResources':
			return 'tabler:plus';
		case 'mainOutcome':
			return 'tabler:plus';
		case 'newImage':
			return 'tabler:photo-plus';
		case 'listattr':
			return 'tabler:list';
		case 'imageattr':
			return 'tabler:photo';
		case 'details':
			return 'tabler:file-description ';
		case 'references':
			return 'tabler:link';
		case 'podcast':
			return 'tabler:brand-apple-podcast';
		case 'prequiz':
			return 'tabler:message-question';
		case 'postquiz':
			return 'tabler:message-question ';
		case 'slideshow':
			return 'tabler:presentation ';
		case 'lngReviewEdit':
			return 'tabler:presentation ';
		case 'askAssistant':
			return 'tabler:message-2-question ';
		case 'finishassistantMode':
			return 'tabler:message-2-question ';
		case 'feedback':
			return 'tabler:message-2-question ';
		case 'notification':
			return 'tabler:bell-ringing';
		case 'feedbackList':
			return 'tabler:message-user';
		case 'print':
			return 'tabler:printer';
		default:
			return 'tabler:settings';
	}
});
const headerTitle = computed(() => {
	if (props.headerTitle) return props.headerTitle
	switch (props.type) {
		case 'new':
			return 'New WI (Package)';
		case 'newmodels':
			return 'Add/Edit WI (Model)';
		case 'inputResources':
			return 'New WI (Working Item)';
		case 'mainOutcome':
			return 'Main Outcome';
		case 'newImage':
			return 'Add new illustration';
		case 'listattr':
			return 'Modify List Attributes';
		case 'imagelist':
			return 'Modify Image List Attributes';
		case 'imageattr':
			return 'Modify Image Attributes';
		case 'details':
			return 'Modify Details Attributes ';
		case 'references':
			return 'Modify References Attributes';
		case 'podcast':
			return 'Modify Podcast Attributes';
		case 'prequiz':
			return 'Modify Pre Quiz Attributes';
		case 'postquiz':
			return 'Modify Post Quiz Attributes ';
		case 'slideshow':
			return 'Add New Overall Slideshow';
		case 'slideshowEdit':
			return 'Modify Slideshow/Podcast Attributes';
		case 'lngReviewEdit':
			return 'Language Reviewer Mode';
		case 'editPackage':
			return 'Modify Package';
		case 'askAssistant':
			return 'Ask Assistant';
		case 'finishassistantMode':
			return 'Recall (Workflow state) Personal Assistant';
		case 'configAssistantMode':
			return 'Configure Assistant';
		case 'complainceAssistantMode':
			return props.headerTitle;
		case 'assistantMode':
			return '[Author] Personal Assistant <-> [UserName] - [Next Workflow State]';
		case 'helpSupportAssistant':
			return props.headerTitle;
		case 'reportassistantMode':
			return props.headerTitle;
		case 'feedbackAssistantMode':
			return props.headerTitle;
		case 'callAssistantMode':
			return props.headerTitle;
		case 'readCallAssistantButton':
			return props.headerTitle;
		case 'feedback':
			return labels.value.leavefeedbackmsg;
		case 'feedbackList':
			return 'Feedbacks list written for this Review Post';
		case 'print':
			return 'Print';
		case 'notification':
			return props.headerTitle;
		default:
			return 'Default Title';
	}
});
const iframeUrl = computed(() => {
	if (props.overrideURL) {
		return props.overrideURL;
	}
	switch (props.type) {
		case 'new':
			return AppConfig.urls.newPackage;
		case 'newmodels':
			return AppConfig.urls.newmodels;
		case 'editmodels':
			return AppConfig.urls.editmodels;
		case 'inputResources':
			return AppConfig.urls.inputResources;
		case 'mainOutcome':
			return AppConfig.urls.inputResources;
		case 'newImage':
			return AppConfig.urls.inputIllutration;
		case 'listattr':
			return AppConfig.urls.editPackage;
		case 'imagelist':
			return AppConfig.urls.editIllutration;
		case 'imageattr':
			return AppConfig.urls.editIllutration;
		case 'details':
			return AppConfig.urls.editDetails;
		case 'references':
			return AppConfig.urls.inputResources;
		case 'podcast':
			return AppConfig.urls.editPodcast;
		case 'prequiz':
			return AppConfig.urls.editPrequiz;
		case 'postquiz':
			return AppConfig.urls.editPostquiz;
		case 'slideshowEdit':
			return AppConfig.urls.editSlideshow;
		case 'slideshowEditFull':
			return AppConfig.urls.editSlideshow;
		case 'askAssistant':
			return AppConfig.urls.inputResources;
		case 'readCallAssistantButton':
			return AppConfig.urls.assistantModeButtons?.finishButton.finishAssistantLink;
		case 'feedback':
			return AppConfig.urls.feedback?.url;
		case 'feedbackList':
			return AppConfig.urls.feedback?.listUrl;
		case 'finishassistantMode':
			return AppConfig.urls.assistantModeButtons?.finishButton.finishAssistantLink;
		case 'complainceAssistantMode':
			return AppConfig.urls.assistantModeButtons?.finishButton.finishAssistantLink;
		case 'helpSupportAssistant':
			return AppConfig.urls.assistantModeButtons?.finishButton.finishAssistantLink;
		case 'reportassistantMode':
			return AppConfig.urls.assistantModeButtons?.finishButton.finishAssistantLink;
		case 'callAssistantMode':
			return AppConfig.urls.assistantModeButtons?.finishButton.finishAssistantLink;
		case 'configButtonMode':
			return AppConfig.urls.assistantModeButtons?.configButton.configAssistantLink;
		case 'assistantMode':
			return AppConfig.urls.assistantModeButtons?.finishButton.finishAssistantLink;
		case 'print':
		    return PrintRoute.value
		case 'slideshow':
		    return presentationRoute.value
		default:
			return AppConfig.urls.newPackage;
	}
});

</script>
<style scoped lang="scss">
.p-component-overlay-enter-animation .animation {
    background-color: rgba(0, 0, 0, 0.4);
}

</style>